import './Recruit.scss'
import './RecruitList.scss'
import './RecruitLanding.scss'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import MainURL from '../../../MainURL'

// 지역 × 직분 랜딩 (/recruit/area/:region/:position?)
// 서버가 같은 데이터로 크롤러용 HTML·메타를 먼저 응답하고, 이 화면은 사용자용으로 다시 그린다.
interface LandingItem {
  kind: string
  id: number
  path: string
  title: string
  church: string
  region: string
  position: string
  depts: string[]
  employment: string[]
  pay: string
  deadline: string
  postedAt: string
}

interface LandingLink {
  path: string
  label: string
  count: number
}

interface LandingData {
  heading: string
  description: string
  items: LandingItem[]
  related: LandingLink[]
}

export default function RecruitLanding() {
  const { region = 'all', position } = useParams()
  const [data, setData] = useState<LandingData | null>(null)
  const [state, setState] = useState<'loading' | 'ok' | 'notFound'>('loading')

  useEffect(() => {
    let cancelled = false
    setState('loading')
    axios
      .get(`${MainURL}/recruitseo/landing/${region}${position ? `/${position}` : ''}`)
      .then((res) => {
        if (cancelled) return
        if (!res.data?.success) {
          setState('notFound')
          return
        }
        setData(res.data)
        setState('ok')
        document.title = `${res.data.heading} | 사역자모아`
      })
      .catch(() => {
        if (!cancelled) setState('notFound')
      })
    return () => {
      cancelled = true
    }
  }, [region, position])

  return (
    <div className="recruit">
      <div className="inner">
        <div className="subpage__main recruit-landing">
          {state === 'loading' && <p className="recruit-landing__empty">불러오는 중...</p>}
          {state === 'notFound' && <p className="recruit-landing__empty">존재하지 않는 페이지입니다.</p>}
          {state === 'ok' && data && (
            <>
              <div className="subpage__main__title">
                <h3>{data.heading}</h3>
              </div>
              <p className="recruit-landing__desc">{data.description}</p>

              {data.items.length === 0 ? (
                <p className="recruit-landing__empty">현재 게시 중인 공고가 없습니다.</p>
              ) : (
                <ul className="recruit-landing__list">
                  {data.items.map((item) => (
                    <li key={`${item.kind}-${item.id}`}>
                      <Link to={item.path} className="recruit-landing__card">
                        <div className="recruit-landing__church">{item.church}</div>
                        <div className="recruit-landing__title">{item.title}</div>
                        <div className="recruit-landing__meta">
                          {[item.region, item.position, item.employment.join('·'), item.pay].filter(Boolean).join(' · ')}
                        </div>
                        <div className="recruit-landing__deadline">{item.deadline}</div>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}

              {data.related.length > 0 && (
                <section className="recruit-landing__related">
                  <h4>관련 공고</h4>
                  <div className="recruit-landing__chips">
                    {data.related.map((link) => (
                      <Link key={link.path} to={link.path} className="recruit-landing__chip">
                        {link.label} <span>{link.count}</span>
                      </Link>
                    ))}
                  </div>
                </section>
              )}

              <Link to="/recruit" className="list-btn recruit-landing__all">
                <span>전체 공고 보기</span>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
